<template>
  <Ebook />
</template>

<script>
import Ebook from "./components/Ebook.vue";

export default {
  name: 'App',
  components: {
    Ebook
  }
}
</script>